<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WcyMWp/tc-custom/9781504040259.jpg?1734205653730" alt="This image is the cover for the book Silent Strength of Stones, The Chapel Hollow Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Silent Strength of Stones, The Chapel Hollow Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>Finalist for the Nebula and World Fantasy Awards: A lonely teenager hides in the forest concealing his own magic—until a battle for survival makes hiding impossible. </b><br/><br/> Summer has come to Sauterelle Lake, a vacation community in the Oregon Cascades, and seventeen-year-old Nick Verrou would rather roam the woods than work in his father’s general store. His curiosity and connection with nature have him dodging his job at every opportunity.<br/>  <br/> When he meets mysterious vacationer Willow and her family—and their unnerving pet wolf—Nick discovers that others share the powers he has tried to suppress. But Nick soon learns that nature’s magic can be more dangerous than he ever imagined. Now the real trick will be surviving until autumn . . .<br/>  <br/><i>The Silent Strength of Stones</i> is the second novel by the author of <i>A Red Heart of Memories</i> and other acclaimed works. “A startling new voice in contemporary fantasy” (<i>Locus</i>), Nina Kiriki Hoffman “writes about magic creatively and with great feeling” (<i>Kirkus Reviews</i>).<br/>  <br/> The Silent Strength of Stones <i>is the 2nd book in the Chapel Hollow Novels, but you may enjoy reading the series in any order. This ebook includes the bonus story “Words of Farewell.”</i><br/>  <br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nina Kiriki Hoffman
      </h2>
      
      <p class="authorDescription body article">Nina Kiriki Hoffman&rsquo;s <I>The Thread That Binds the Bones</I> won the Bram Stoker Award for First Novel. Its follow-up, <I>The Silent Strength of Stones,</I> was a finalist for the Nebula and World Fantasy Awards. In addition to writing, Hoffman teaches, has worked part-time at a bookstore, and does production work for <I>Fantasy &amp; Science Fiction </I>magazine. She sings and plays guitar, mandolin, and fiddle, among other instruments, performing regularly at various granges and other venues near her home in Eugene, Oregon.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?745f2a55